export const QUESTION_MODAL_TEXT = {
  FORM: {
    LABELS: {
      QUESTION: "Question",
      TYPE: "Type*",
      OPTION: "Option",
      PLACEHOLDER: "Enter your question",
    },
    BUTTONS: {
      CANCEL: "Cancel",
      SUBMIT: "Submit",
      UPDATE: "Update",
      DUPLICATE: "Duplicate",
      ADD_OPTION: "Add Option",
    },
    SELECT: {
      CATEGORY_PLACEHOLDER: "Select Category",
    },
  },
  ERRORS: {
    OPTION_FETCH: "Error fetching options:",
    QUESTION_SUBMIT: "Error submitting question:",
    QUESTION_OPTION_ASSOCIATION: "Failed to create question-option association",
    QUESTION_CREATE: "Failed to create/update question",
  },
  VALIDATION: {
    REQUIRED_FIELDS: {
      QUESTION: "Question is required",
      TYPE: "Type is required",
    },
  },
};

export const OPTION_MODAL_TEXT = {
  FORM: {
    LABELS: {
      OPTION: "Option*",
      TYPE: "Type*",
      CATEGORY: "Category*",
      OPTION_PLACEHOLDER: "Enter option",
      OTHER_CATEGORY_PLACEHOLDER: "Enter other category",
    },
    BUTTONS: {
      CANCEL: "Cancel",
      SUBMIT: "Submit",
      UPDATE: "Update",
      DUPLICATE: "Duplicate",
    },
    SELECT: {
      CATEGORY_PLACEHOLDER: "Select Category",
    },
  },
  ERRORS: {
    CATEGORY_CREATE: "Failed to create category",
    SUBMIT: "Error submitting:",
  },
  TYPE_OPTIONS: [
    { value: "string", label: "String" },
    { value: "number", label: "Number" },
    { value: "boolean", label: "Boolean" },
  ],
  OTHER_VALUE: "Other",
};

// Common form field values
export const COMMON_FORM_FIELDS = {
  STATUS: {
    DRAFT: "draft",
    PUBLISHED: "published",
  },
  TEST_IDS: {
    OPTION_INPUT: "option-input",
    OTHER_CATEGORY_FIELD: "other-category-field",
    OTHER_CATEGORY_INPUT: "other-category-input",
    CANCEL_BUTTON: "cancel-button",
    SUBMIT_BUTTON: "submit-button",
  },
};

export const DEFINED_ROLES = [
  "mahatria",
  "admin",
  "finance_manager",
  "relational_manager",
  "shoba",
  "operational_manger",
];

export const TDS_APPLICATION_OPTIONS = [
  { value: "", label: "Select option" },
  { value: "base_only", label: "Base amount" },
  {
    value: "base_plus_tax",
    label: "Base amount with tax",
  },
];

export const PAYMENT_STATUSES = {
  ONLINE_PENDING: {
    value: "online_pending",
    label: "Online pending",
  },
  ONLINE_COMPLETED: {
    value: "online_completed",
    label: "Online completed",
  },
  OFFLINE_PENDING: {
    value: "offline_pending",
    label: "Offline pending",
  },
  OFFLINE_COMPLETED: {
    value: "offline_completed",
    label: "Offline completed",
  },
};

export const  ApprovalStatus = {
  PENDING : 'pending',
  APPROVED : 'approved',
  REJECTED : 'rejected',
  UNDER_REVIEW : 'under_review',
  ON_HOLD : 'on_hold',
}
